import { Apis } from "../../lib/Apis";

const unwrapResponseBody = (body) => {
  if (body == null) return null;
  if (body?.success === false) {
    throw new Error(body?.message || "Request failed.");
  }
  if (
    body &&
    typeof body === "object" &&
    "data" in body &&
    ("success" in body || "statusCode" in body)
  ) {
    return body.data;
  }
  return body;
};

const unwrapListPayload = (body) => {
  const payload = unwrapResponseBody(body) ?? body ?? {};
  const items = Array.isArray(payload?.data)
    ? payload.data
    : Array.isArray(payload)
      ? payload
      : [];
  const pagination = payload?.pagination ?? body?.pagination ?? null;
  const totalCount =
    pagination?.totalRecords ??
    pagination?.totalCount ??
    pagination?.totalItems ??
    items.length;
  return { items, pagination, totalCount, payload };
};

export const useDesignContracts = () => {
  const createDesignContract = async (formData) => {
    const response = await Apis.postDesignContract(formData);
    return unwrapResponseBody(response?.data) ?? response?.data;
  };

  const getDesignContracts = async (offset = 0, limit = 10, params = {}) => {
    const response = await Apis.getDesignContracts(offset, limit, params);
    const { items, pagination, totalCount } = unwrapListPayload(response?.data);
    return { data: items, pagination, totalCount };
  };

  const getDesignContractById = async (id) => {
    const response = await Apis.getDesignContractById(id);
    return unwrapResponseBody(response?.data);
  };

  const updateDesignContract = async (id, data) => {
    const response = await Apis.updateDesignContract(id, data);
    return unwrapResponseBody(response?.data);
  };

  const deleteDesignContract = async (id) => {
    const response = await Apis.deleteDesignContract(id);
    return unwrapResponseBody(response?.data) ?? response?.data;
  };

  const getUserDesignContracts = async (params) => {
    try {
      const response = await Apis.getUserDesignContracts(params);
      const { items, pagination, totalCount, payload } = unwrapListPayload(
        response?.data,
      );
      if (items.length || pagination) {
        return { data: items, pagination, totalCount, ...payload };
      }
      return response.data;
    } catch (error) {
      console.error("Error fetching user design contracts:", error);
      throw error;
    }
  };

  return {
    createDesignContract,
    getDesignContracts,
    getDesignContractById,
    updateDesignContract,
    deleteDesignContract,
    getUserDesignContracts,
  };
};
